import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCustomTasksApi } from "../../http/customTasks/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteSubsidiaryCustomTaskDialogProps = {
  subsidiaryId: string;
  defaultTaskCategory: string;
  onClose: () => void;
};

const DeleteSubsidiaryCustomTaskDialog: FC<DeleteSubsidiaryCustomTaskDialogProps> = ({
  subsidiaryId,
  onClose,
  defaultTaskCategory,
}) => {
  const i18n = useI18n();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const customTasksApi = useCustomTasksApi();

  const onDelete = async () => {
    setIsSubmitting(true);
    await customTasksApi
      .deleteAdminSubsidiaryCustomTasks(subsidiaryId, defaultTaskCategory)
      .then(() => onClose())
      .catch((err) => dispatch(showErrorNotification(i18n, err)))
      .finally(() => setIsSubmitting(false));
  };
  return (
    <ModalDialog
      title={i18n.t.tasksCategories.delete}
      onClose={() => onClose()}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          disabled: isSubmitting,
          type: "secondary",
          onClick: () => onClose(),
        },
        {
          title: i18n.t.common.delete,
          disabled: isSubmitting,
          onClick: onDelete,
        },
      ]}
    >
      {i18n.t.tasksCategories.questions.deleteSubsidiaryCustomTasks}
    </ModalDialog>
  );
};

export default DeleteSubsidiaryCustomTaskDialog;
